import GlobalStore from "@ipru-common/store/GlobalStore";
import { mapDataToSuitabilityData } from "@ipru-common/components/CommonComponents/SuitabilityCalModal/SuitabilityMapper";
import { yesNo } from "../SavingsAppForm/SavingAppFormsUtils";
import { convertToISODate, getSelectedFunds, readQueryParams } from "@ipru-common/utils/CommonFunctions";
import { PRODUCT_NAMES } from "@ipru-common/constants/products";

const getSIPPlusNetCoreInput = () => {
  const { appFormData, quoteFormData, calculatorFormData, currentPageStep } = GlobalStore.getSnapshot();
  const suitabilityData = mapDataToSuitabilityData(calculatorFormData, quoteFormData);
  const queryParams = readQueryParams();
  const { personalDetails } = appFormData;
  let Maturity_benefit_4_Value = suitabilityData?.calculatedData ? getOnlineReturnByRate(suitabilityData, 4) : "";
  let Maturity_benefit_8_Value = suitabilityData?.calculatedData ? getOnlineReturnByRate(suitabilityData, 8) : "";
  const selectedfunds = quoteFormData?.allocatedFunds ? getSelectedFunds(quoteFormData?.allocatedFunds) : 0;
  const { familyIncomePercent } = quoteFormData;
  const fundData = Array.isArray(quoteFormData?.fundDataValue) ? quoteFormData.fundDataValue : [];

  let Perf1Year = "";
  let Perf3Year = "";
  let Perf5Year = "";
  if (selectedfunds?.length > 0) {
    Perf1Year = selectedfunds[0]?.Perf1Year ?? "";
    Perf3Year = selectedfunds[0]?.Perf3Year ?? "";
    Perf5Year = selectedfunds[0]?.Perf5Year ?? "";
  }

  const urlParams = new URLSearchParams(window?.location?.search);
  const params = Object.fromEntries(urlParams?.entries());

  let signatureSipPlusInput = {
    age: calculatorFormData?.age,
    DOB: convertToISODate(calculatorFormData?.user_dob),
    gender: calculatorFormData?.gender,
    QDATA: queryParams?.get("qdata") ?? "",
    Lifecover: quoteFormData?.lifeCover,
    Payment_frequency: quoteFormData?.paymentFrequency,
    mobileno: calculatorFormData?.mobileno,
    emailid: calculatorFormData?.emailid,
    Premium: quoteFormData?.invest + +quoteFormData?.riderPremium,
    occupation: calculatorFormData?.calc_occupation,
    ppt: quoteFormData?.ppt,
    Maturity_benefit_4: Maturity_benefit_4_Value,
    Maturity_benefit_8: Maturity_benefit_8_Value,
    fund_performance_1: Perf1Year,
    fund_performance_3: Perf3Year,
    fund_performance_5: Perf5Year,
    Fund_name: selectedfunds?.length > 0 ? selectedfunds[0]?.Fund : (quoteFormData?.selectedFund ?? ""),
    SWP_opted: suitabilityData?.swpExpand == "Yes" ? "Yes" : "No",
    SWP_type_opted: suitabilityData?.swpExpand == "Yes" ? (suitabilityData?.Goal ?? "") : "",
    maritalstatus: personalDetails?.marital_status,
    Quote_page_health_questionnaire: quoteFormData?.healthQuestion ?? "",
    appno: appFormData?.appNO,

    // // NOT IN SIGNATURE NET CORE , BUT NEEDED BEC OF COMMON IMPLEMENTATION
    currentpagestep: currentPageStep,
    isenglish: params?.lan === "hindi" || params?.lan === "hi" ? "FALSE" : "TRUE",
    trai_flag: yesNo(calculatorFormData?.trai_flag),

    pagename: PRODUCT_NAMES.SipPlus,
    "familyincome%": familyIncomePercent,
    isEnglish: "ENGLISH",
    Maturity_benefit_FP1: quoteFormData?.returnYears === 1 ? quoteFormData?.pastPerformanceValue : "",
    Maturity_benefit_FP3: quoteFormData?.returnYears === 3 ? quoteFormData?.pastPerformanceValue : "",
    Maturity_benefit_FP5: quoteFormData?.returnYears === 5 ? quoteFormData?.pastPerformanceValue : "",
    ...Object.fromEntries(
      fundData
        ?.map((item, index) => [
          [`investment_value_${index + 1}`, item.fund],
          [`fund_value_${index + 1}`, item.growth],
        ])
        .flat()
    ),
  };

  return signatureSipPlusInput;
};

function getOnlineReturnByRate(data, rate) {
  try {
    if (
      !data ||
      !data.calculatedData ||
      !data.calculatedData.returns ||
      !Array.isArray(data.calculatedData.returns.arr)
    ) {
      return null; // invalid data structure
    }

    const match = data.calculatedData.returns.arr.find((item) => item.rateOfInterest === rate);
    return match ? match.onlineReturn : null;
  } catch (err) {
    console.log("Error while getting percentage return", err);
    return "";
  }
}

export default getSIPPlusNetCoreInput;
